export default {
  'app.pwa.offline': 'Вы сейчас офлайн',
  'app.pwa.serviceworker.updated': 'Доступен новый контент',
  'app.pwa.serviceworker.updated.hint':
    'Пожалуйста, нажмите кнопку "Обновить", чтобы перезагрузить текущую страницу',
  'app.pwa.serviceworker.updated.ok': 'Обновить',
};
